import React from 'react'
import SubAdmin from '../masterLayout/SubAdmin'
import Breadcrumb from '../components/Breadcrumb'
import ManagerMapping from '../components/child/ManagerMapping'

const StucredManagerMapping = () => {
  return (
        <SubAdmin>
        <Breadcrumb title="Manager Mapping" />
        <ManagerMapping />


    </SubAdmin> 
     )
}

export default StucredManagerMapping